import {
    TOKEN,
} from './types';


export const tokenRegister = (token) => {
    return {
        type: TOKEN,
        payload:token
    };
};
